module.exports = __webpack_public_path__ + "img/emilie.9cc8f785.png";